import type { Reference, ServiceRequest } from '@medplum/fhirtypes'
import { Order } from '@seen/core/models/orders/Order'
import type { ReactNode } from 'react'
import { useRead } from '#src/hooks/useRead.ts'
import { getOrderTitle } from '#src/utils/getOrderTitle.ts'

export function OrderDetailDisplayInline({
  order: orderRef,
}: {
  order: Order | Reference<ServiceRequest>
}): ReactNode {
  const orderRefString =
    orderRef instanceof Order ? orderRef.reference : orderRef
  const { data: order } = useRead(Order, orderRefString)

  if (!order) {
    return null
  }

  const title = getOrderTitle(order)

  return (
    <span className="flex w-full items-center overflow-hidden text-sm">
      <span className="font-medium whitespace-nowrap">
        {order.categoryCodeDisplay}:&nbsp;
      </span>
      <span className="truncate">{title}</span>
    </span>
  )
}
